import DiagnosticsStore from "@/features/diagnostics/store/diagnostics-store.ts";

export default class ContextNotInitializedException extends Error {
    constructor(provider: string) {
        const message = `Element must be wrapped inside <${provider} />`;

        super(message);

        DiagnosticsStore.collectEventLog("error", message);
    }
}
